var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.discount)?_c('span',[_vm._v(_vm._s(_vm.discount.name)),(_vm.preferred)?_c('b-tooltip',{attrs:{"label":_vm.$t('discount.preferred_tooltip')}},[_c('span',{staticClass:"icon has-text-danger is-small"},[_c('i',{staticClass:"mdi mdi-heart"})])]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }